export const ACCOUNT_PROFILE = 'account.profile';

export const lblProfileSurveyQuestion1 = 'lbl_profile_survey_question1';
export const lblProfileSurveyQuestion2 = 'lbl_profile_survey_question2';
export const lblProfileAboutYouModalHeading = 'lbl_profile_about_you_modal_heading';

const AboutYouInformationLabels = {
  account: {
    profile: {
      [lblProfileSurveyQuestion1]: 'How would you best describe yourself?',
      [lblProfileSurveyQuestion2]: 'Who are you shopping for?',
      [lblProfileAboutYouModalHeading]: 'MORE ABOUT YOU',
    },
  },
};
export default AboutYouInformationLabels;
